import React from 'react';
import styled from 'styled-components';
import { color, pxToRem } from '../utils';
import statusSuccess from '../assets/icons/status-success.svg';
import statusDanger from '../assets/icons/status-danger.svg';
import statusWarning from '../assets/icons/status-warning.svg';

const captionsCertificateControl = [
  {
    color: color.success,
    icon: statusSuccess,
    meaning: 'Certificado válido'
  },
  {
    color: color.warning,
    icon: statusWarning,
    meaning: 'Certificado a vencer'
  },
  {
    color: color.danger,
    icon: statusDanger,
    meaning: 'Certificado vencido'
  },
];

const CaptionsArea = styled.div`
  font-size: ${pxToRem(14)};
  width: 100%;
`;

const CaptionWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: ${({notFirst}) => (notFirst ? '5px' : '0')};

  span {
    margin-left: 10px;
  }
`;

const Status = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: ${(props) => props.color};
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 14px;
    height: 14px;
  }
`;

export const CaptionsCertificateControl = () => {
  return (
    <CaptionsArea>
      {captionsCertificateControl.map((caption, index) => (
        <CaptionWrapper key={index} notFirst={index !== 0}>
          <Status color={caption.color}>
            <img src={caption.icon} alt={caption.meaning} />
          </Status>
          <span>{caption.meaning}</span>
        </CaptionWrapper>
      ))}
    </CaptionsArea>
  );
};



// WEBPACK FOOTER //
// ./src/components/CaptionsCertificateControl.js